import React from 'react';
import { FadeIn } from './FadeIn';
import { GiftIcon, ZapIcon, CalendarDaysIcon, BarChart2Icon, MessageSquareHeartIcon, ClipboardCheckIcon, UsersIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: <ZapIcon className="w-6 h-6" data-id="element-15" />,
    title: 'Kit de Planificación Pro',
    desc: 'Todas las plantillas, fichas y planes prearmados para implementar el sistema desde el primer día. Macrociclos, mesociclos y microciclos listos para personalizar.'
  }, {
    icon: <UsersIcon className="w-6 h-6" data-id="element-16" />,
    title: 'Sistema de Gestión de Grupos',
    desc: 'El sistema completo para clasificar alumnos por nivel, diseñar sesiones diferenciadas y escalar sin que la calidad caiga.'
  }, {
    icon: <BarChart2Icon className="w-6 h-6" data-id="element-17" />,
    title: 'Sistema de Evaluación Completo',
    desc: 'Tests de campo estandarizados, fichas de seguimiento individual e informes mensuales que convierten el progreso invisible en evidencia concreta.'
  }, {
    icon: <MessageSquareHeartIcon className="w-6 h-6" data-id="element-18" />,
    title: 'Running Pro Academy (Video)',
    desc: 'Módulos en video con análisis biomecánico de corredores reales, demostración de los 15 drills y sesiones de entrenamiento en vivo.'
  }, {
    icon: <ClipboardCheckIcon className="w-6 h-6" data-id="element-19" />,
    title: 'Mentoría y Comunidad VIP',
    desc: 'Acceso al grupo privado de los mejores entrenadores de running en habla hispana. Revisión mensual de planes, sesión grupal en vivo y soporte diario.'
  }, {
    icon: <CalendarDaysIcon className="w-6 h-6" data-id="element-20" />,
    title: 'Guía de Psicología del Corredor',
    desc: 'Las herramientas mentales que separan al corredor que llega de la meta del que abandona. Scripts para cada conversación difícil con tus alumnos.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-running-dark" data-id="element-21">
      <div className="max-w-6xl mx-auto" data-id="element-22">
        <FadeIn data-id="element-23">
          <div className="text-center mb-16" data-id="element-24">
            <div className="inline-flex items-center justify-center gap-2 bg-running-blue/10 text-running-blue px-4 py-2 rounded-full font-bold mb-6" data-id="element-25">
              <GiftIcon className="w-5 h-5" data-id="element-26" />
              <span data-id="element-27">MÓDULOS ADICIONALES INCLUIDOS</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-display font-bold text-white max-w-3xl mx-auto" data-id="element-28">
              Y además de los 6 tomos principales, el bundle incluye los módulos
              que completan el sistema total.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-29">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-30">
              <div className="bg-running-surface border border-running-muted p-6 sm:p-8 rounded-2xl h-full flex flex-col hover:border-running-blue/30 transition-colors" data-id="element-31">
                <div className="bg-running-dark w-12 h-12 rounded-full flex items-center justify-center text-running-blue mb-6 border border-running-muted" data-id="element-32">
                  {bonus.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-3" data-id="element-33">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-34">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}